import React from 'react';
import { Sparkles, ChevronDown } from 'lucide-react';

interface BookListLoadMoreProps {
  displayedCount: number;
  totalCount: number;
  onLoadMore: () => void;
}

export const BookListLoadMore: React.FC<BookListLoadMoreProps> = ({
  displayedCount,
  totalCount,
  onLoadMore,
}) => {
  const remainingCount = totalCount - displayedCount;

  return (
    <div className="mt-8 text-center pt-2 pb-4">
      <div className="inline-flex flex-col items-center gap-3">
        <p className="text-xs text-slate-500 font-medium">
          Menampilkan <span className="font-bold text-slate-800">{displayedCount}</span> dari{' '}
          <span className="font-bold text-slate-800">{totalCount}</span> naskah buku
        </p>

        <button
          type="button"
          id="btn-load-more-books"
          onClick={onLoadMore}
          className="px-6 py-2.5 rounded-xl bg-white hover:bg-indigo-50 border border-slate-300 hover:border-indigo-300 text-slate-800 hover:text-indigo-700 font-bold text-xs sm:text-sm shadow-2xs hover:shadow-md transition duration-200 flex items-center justify-center gap-2 cursor-pointer group active:scale-98"
        >
          <Sparkles className="w-4 h-4 text-indigo-600 group-hover:rotate-12 transition-transform duration-200" />
          <span>Muat Lebih Banyak ({remainingCount} sisa)</span>
          <ChevronDown className="w-4 h-4 text-slate-400 group-hover:text-indigo-600 group-hover:translate-y-0.5 transition-transform duration-200" />
        </button>
      </div>
    </div>
  );
};
